import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import "./AfterAuthHeader.scss";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { IsNewIcon } from "../../../assets/images";
import toast from "react-hot-toast";
import {
  logoutUserAction,
  resetSession,
  userProfileAction,
} from "../../../redux/auth";
import { connect } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import { CircularAvatar, ErrorSuccessModal } from "../../../components/commons";
import { getUserProfileAction } from "../../../redux/auth";
import { UserProfileType } from "../../../redux/auth/authTypes";
import { getMaintenanceDataAction } from "../../../redux/maintenance";
import Notification from "../../../screens/Notification";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import { Attendance } from "../../../screens";
import { MenuType } from "../../../redux/userManagement/userManagementTypes";
import { getWellcomeMessage } from "../../../screens/Attendance";
import { AttendanceDataType } from "../../../redux/notification/notificationTypes";
import Breadcrumbs from "../../BreadCrumbs/breadCrumbs";
import Socket from "../../../screens/Notification/Socket";

type AppProps = {
  history?: any;
  dispatchLogoutUser: (token: string | null) => void;
  dispatchGetUserProfileAction: (token: string) => void;
  dispatchUserProfileData: (data: any) => void;
  dispatchGetMaintenanceDataAction: () => void;
  persistUserProfileAllData: UserProfileType;
  dispatchLogout: () => void;
  token: string | null;
  error: string | null;
  statusCode: any;
  loginData: any;
  toggle: any;
  handleToggle: any;
  othersList: [] | MenuType[];
  startingAttendenceData: AttendanceDataType | null;
};

const AfterAuthHeader = ({
  dispatchLogoutUser,
  dispatchGetUserProfileAction,
  dispatchGetMaintenanceDataAction,
  dispatchLogout,
  persistUserProfileAllData,
  dispatchUserProfileData,
  error,
  statusCode,
  token,
  history,
  loginData,
  toggle,
  handleToggle,
  othersList,
  startingAttendenceData,
}: AppProps) => {
  const user_id =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.userData &&
    history.location.state.userData.user_id
      ? history.location.state.userData.user_id
      : 0;
  const [showModal, setShowModal] = useState<boolean>(false);
  const [profileImg, setProfileImg] = useState<string>("");
  const [fullName, setFullName] = useState<string>("");
  const [authCount, setAuthCount] = useState<number>(0);
  const [seconds, setSeconds] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [hours, setHours] = useState(0);
  const [startTimer, setStartTimer] = useState(false);
  const [timerStartMessage, setTimerStartMessage] = useState("");
  const [showToast, setShowToast] = useState("");
  const [isInitialRender, setIsInitialRender] = useState(true);
  const location = useLocation();
  const searchParams = location.search
    ? new URLSearchParams(location?.search)
    : new URLSearchParams(history?.location?.pathname.split("?")[1]);
  const redirectNotificationId = searchParams.get("notification_id");
  const handleLogoutUser = () => {
    dispatchLogoutUser(token);
    dispatchLogout();
  };

  //====================User Managent=============================
  const [isNotificationPresent, setIsNotificationPresent] = useMenuCheck();
  const [isAttendancePresent, setIsAttendancePresent] = useMenuCheck();
  //=================================================================
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    toast.remove();
    setIsNotificationPresent("Notification", "menu");
    setIsAttendancePresent("Attendance", "menu");
    return () => toast.dismiss();
  }, []);

  const handleErrorSuccessModal = () => {
    if (statusCode === 401) {
      return (
        <ErrorSuccessModal
          toggle={showModal}
          isOpen={statusCode === 401}
          title="Session Expired"
          message="Please login again!"
          onPress={() => {
            dispatchLogout();
            setShowModal(false);
          }}
          statusCode={statusCode}
          buttonText="Logout"
          type="error"
        />
      );
    }

    return false;
  };

  const handleGetUserProfile = () => {
    if (token) {
      dispatchGetUserProfileAction(token);
    }
  };

  // Commented for future use toast for start timer
  //   useEffect(()=>{
  //     toast.dismiss()

  //     if(!isInitialRender){
  //       if((timerStartMessage === "" || timerStartMessage === "Check In") && isAttendancePresent){
  //         toast(
  //           (t) => (
  //             <div className="toast-content">
  //               <span>
  //               {getWellcomeMessage()}! Please DO NOT forget to start your
  //                 attendance timer. Have a great day ahead!
  //               </span>
  //               <span className="delete-button" onClick={() => toast.dismiss(t.id)}>
  //                 <img src={RedCloseWithLightColorIcon} alt="delete" />
  //               </span>
  //             </div>
  //           ),
  //           {
  //             duration: Infinity,
  //             position: "top-center",
  //             style: {
  //               backgroundColor: "#fff5e5",
  //               maxWidth: "900px",
  //               border: "1px solid #be7e12",
  //               color: "#be7e12",
  //               fontSize: "15px",
  //               fontWeight:500,
  //               paddingTop:"5px",
  //             },
  //             ariaProps: {
  //               role: "status",
  //               "aria-live": "polite",
  //             },
  //           }
  //         );
  //       }
  //       else{
  //         toast.dismiss()
  //       }
  //     }

  //   },[isAttendancePresent,timerStartMessage])

  //   useEffect(() => {
  //     const initialRenderTimeout = setTimeout(() => {
  //       setIsInitialRender(false);
  //     }, 0);

  //     return () => clearTimeout(initialRenderTimeout);
  //   }, []);

  // useEffect(() => {
  //   const storedIsInitialRender = localStorage.getItem('isInitialRender');
  //   if (storedIsInitialRender !== null) {
  //     toast.dismiss()
  //     setIsInitialRender(storedIsInitialRender === 'true');
  //   }
  // }, []);

  // useEffect(() => {
  //   localStorage.setItem('isInitialRender', String(isInitialRender));
  // }, [isInitialRender]);

  useEffect(() => {
    if (location?.pathname === "/user-clients-list") {
      if (token) {
        let final_data = {
          token,
          user_id,
        };
        dispatchUserProfileData(final_data);
      }
    }
  }, [persistUserProfileAllData?.user_details?.profile_pic?.file_url]);

  useEffect(() => {
    dispatchGetMaintenanceDataAction();
  }, []);

  useEffect(() => {
    setProfileImg(loginData?.profile_pic?.file_url);
    setFullName(loginData?.first_name + " " + loginData?.last_name);
  }, [
    loginData,
    loginData?.profile_pic?.file_url,
    loginData?.first_name,
    loginData?.last_name,
  ]);
  return (
    <>
      <header
        className=""
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          alignItems: "center",
          position: "relative",
        }}
      >
        {windowWidth > 430 ? (
          <Breadcrumbs />
        ) : (
          <div className="flex-center pl-3 breadCrum"></div>
        )}

        <nav className="mobile-nav">
          {/* <div className=""> */}
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex profile-section">
              <div></div>

              <div className="d-flex">
                <div className="btn-group mr-3 d-flex align-items-center">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://forms.office.com/r/CmavWvTppv"
                  >
                    <button
                      className="btn btn-primary mt-1"
                      style={{ position: "relative", padding: "3px 10px" }}
                    >
                      Take a Loan
                      <div
                        className="new_icon"
                        style={{
                          // padding: "1.5px 20px",
                          position: "absolute",
                          top: "-2.2px",
                          right: "-4.2px",
                        }}
                      >
                        <img
                          src={IsNewIcon}
                          alt=""
                          style={{
                            height: "21.6px",
                            width: "30px",
                          }}
                        />
                      </div>
                    </button>
                  </a>
                </div>
                {isAttendancePresent && (
                  <Attendance
                    seconds={seconds}
                    minutes={minutes}
                    hours={hours}
                    startTimer={startTimer}
                    setSeconds={setSeconds}
                    setMinutes={setMinutes}
                    setHours={setHours}
                    setStartTimer={setStartTimer}
                    setTimerStartMessage={setTimerStartMessage}
                  />
                )}
                <Notification history={history} />
                {/* <Socket showToast={showToast} /> */}
                <div className="d-flex align-items-center">
                  <UncontrolledDropdown className="profile-nav">
                    <DropdownToggle
                      className="toggle-button"
                      tag="span"
                      data-toggle="dropdown"
                      caret
                    >
                      {
                        // loginData?.profile_pic?.file_url===false ? <img src={User} alt="logo" className="profile-dropdown" />
                        // :
                        <CircularAvatar
                          name={fullName}
                          image={profileImg}
                          afterHeaderClassName={"profile-dropdown"}
                        />
                      }
                    </DropdownToggle>
                    <DropdownMenu right>
                      {/* <Link to='/profile'>
                    <DropdownItem onClick={handleGetUserProfile}>
                      Profile
                    </DropdownItem>
                  </Link> */}
                      {loginData?.user_type == 1 ? (
                        <>
                          <Link to="/my-space">
                            <DropdownItem>My Space</DropdownItem>
                          </Link>
                          <DropdownItem divider />
                        </>
                      ) : (
                        ""
                      )}
                      <Link to="/settings">
                        <DropdownItem>Settings</DropdownItem>
                      </Link>
                      <DropdownItem divider />
                      <DropdownItem onClick={handleLogoutUser}>
                        Logout
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>
      {/* {handleErrorSuccessModal()} */}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  error: state.auth.error,
  statusCode: state.auth.statusCode,
  loginData: state.auth.loginData,
  persistUserProfileAllData: state.auth.persistUserProfileAllData,
  othersList: state.auth.others,
  startingAttendenceData: state.notification.attendence,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchLogoutUser: (token: string | null) =>
    dispatch(logoutUserAction(token)),
  dispatchLogout: () => dispatch(resetSession()),
  dispatchGetMaintenanceDataAction: () => dispatch(getMaintenanceDataAction()),
  dispatchGetUserProfileAction: (token: string) =>
    dispatch(getUserProfileAction(token)),
  dispatchUserProfileData: (data: any) => dispatch(userProfileAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AfterAuthHeader);
